import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { disconnectService as disconnectServiceAction } from 'pages/Services/actions';
import { getIsoDate } from 'utils/dates';

import { Button, Emoji, Heading, HTML, Preloader } from 'components';

import classNames from 'classnames/bind';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

const ServiceDisconnectForm = (props) => {
  const {
    service,
    disconnectService,
    content,
    onErrorBtnClick,
    onSuccess,
    onSetPending,
  } = props;
  const [step, setStep] = useState('initial');

  const onDisconnectClick = () => {
    setStep('loading');
    onSetPending({ soc: null, connected: true });
    disconnectService(getIsoDate(new Date()), service.soc, service.name)
      .then((data) => {
        if (data.isSucceeded && (data?.result !== -1)) {
          setStep('success');
        } else {
          setStep('error');
        }
      })
      .catch(() => setStep('error'));
  };

  if (step === 'success') {
    onSuccess();
    onSetPending({ soc: service.soc, connected: false });
    return null;
  }

  return (
    <div className={cx('wrapper')}>
      {step === 'loading' && (
        <div className={cx('loaderWrap')}>
          <div className={cx('loader')}>
            <Preloader size="50" isStyled={false} />
          </div>
          <HTML as="div">
            {content.disconnectionWait}
          </HTML>
        </div>
      )}
      {step === 'initial' && (
        <>
          <Heading level={1} isStyled={false}>
            {service.name}
          </Heading>
          <HTML as="div" className={cx('description')}>
            {content.description}
          </HTML>
          <div className={cx('btnWrap')}>
            <Button
              type="button"
              className="big"
              onClick={onDisconnectClick}
              wide
            >
              {content.disconnectBtn}
            </Button>
          </div>
        </>
      )}
      {step === 'error' && (
        <>
          <div className={cx('errorEmojiWrap')}>
            <Emoji className={cx('errorEmoji')} name="smile-sad" />
          </div>
          <HTML as="div" className={cx('errorTitle')}>{content.errorData.title}</HTML>
          <HTML as="div" className={cx('errorDescription')}>
            {content.errorData.description}
          </HTML>
          <div className={cx('btnWrap')}>
            <Button
              type="button"
              className="big"
              onClick={onErrorBtnClick}
              wide
            >
              {content.errorData.btn}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

ServiceDisconnectForm.propTypes = {
  service: PropTypes.shape({
    name: PropTypes.string,
    soc: PropTypes.string,
  }),
  content: PropTypes.shape({
    description: PropTypes.string,
    disconnectBtn: PropTypes.string,
    disconnectionWait: PropTypes.string,
    errorData: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      btn: PropTypes.string,
    }),
  }),
  disconnectService: PropTypes.func,
  onErrorBtnClick: PropTypes.func,
  onSuccess: PropTypes.func,
  onSetPending: PropTypes.func,
};

const mapDispatchToProps = {
  disconnectService: disconnectServiceAction,
};

export default connect(null, mapDispatchToProps)(ServiceDisconnectForm);
